export const GUEST_CHARS_PER_MONTH = 1_000
export const FREE_CHARS_PER_MONTH = 2_500
export const PRO_CHARS_PER_MONTH = 250_000
export const PRO_CHARS_PER_YEAR = 3_000_000

export const GUEST_CHARS_PER_TRANSLATION = 500
export const FREE_CHARS_PER_TRANSLATION = 500
export const PRO_CHARS_PER_TRANSLATION = 20_000

// Voice, image, and PDF translation are Pro-only features. Guests + free users
// get text translation only — see /api/extension/{tts,translate-image,translate-pdf}.
export const FREE_IMAGE_TRANSLATIONS_PER_MONTH = 0
export const FREE_PDF_TRANSLATIONS_PER_MONTH = 0
export const PRO_IMAGE_TRANSLATIONS_PER_MONTH = 40
export const PRO_PDF_TRANSLATIONS_PER_MONTH = 10

// ── TTS (ElevenLabs voice) quotas ───────────────────────────────────────────
// Guests + free: no TTS access (Pro-only feature).
// Pro monthly: 5,000 chars/month. Pro yearly: 60,000 chars/year.
export const FREE_TTS_CHARS_PER_MONTH = 0
export const PRO_TTS_CHARS_PER_MONTH = 5_000
export const PRO_TTS_CHARS_PER_YEAR = 60_000
